import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Content } from '../../../infrastructure/content';
import EmailAddress from '../../businessContactDetailsQuestion/components/EmailAddress';
import BusinessNumber from '../../businessContactDetailsQuestion/components/BusinessNumber';
import PreferredContactMethod from '../../businessContactDetailsQuestion/components/PreferredContactMethod';
import { onKeyPress, isDisabledBasedOnRedirectUri } from '../../../utils';

class ContactDetailsAccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEdit: false };
    this.saveContactChanges = this.saveContactChanges.bind(this);
    this.contactEditClick = this.contactEditClick.bind(this);
  }
  contactEditClick() {
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(false);
  }

  renderContactType(values) {
    const { getBusinessData } = this.props;

    if (!this.state.isEdit) {
      return (
        <Content>
          {({
            businessContactDetailsEmailLabel,
            businessContactDetailsTelLabel,
            businessContactDetailsPreferredContactLabel
          }) => (
            <GenericDescriptionList
              items={[
                { key: businessContactDetailsEmailLabel, value: getBusinessData.emailAddress },
                { key: businessContactDetailsTelLabel, value: getBusinessData.businessNumber },
                {
                  key: businessContactDetailsPreferredContactLabel,
                  value: getBusinessData.preferredContactMethod
                }
              ]}
            />
          )}
        </Content>
      );
    }

    return (
      <div>
        <EmailAddress values={values} />

        <BusinessNumber values={values} disabled={isDisabledBasedOnRedirectUri()} />

        <PreferredContactMethod values={values} disabled={isDisabledBasedOnRedirectUri()} />
      </div>
    );
  }

  saveContactChanges(e) {
    this.props.saveContactChanges(e);
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(true);
  }

  render() {
    const { getBusinessData, onValueChanges, linkCode, onCancelEditClick } = this.props;
    const { isEdit } = this.state;

    return (
      <div>
        <Form
          onSubmit={this.saveContactChanges}
          initialValues={getBusinessData}
          render={({ handleSubmit, values }) => (
            <form
              onSubmit={handleSubmit}
              onKeyPress={onKeyPress}
              onChange={() => {
                onValueChanges(true);
              }}
            >
              {this.renderContactType(values)}

              {isEdit && (
                <Content>
                  {({ confirmChanges, changesNotSavedText }) => (
                    <div className="u-margin-top-2 u-margin-bottom-2">
                      <ActionButton.Primary
                        labelText={confirmChanges}
                        onClick={() => this.saveContactChanges(values)}
                      />
                      <p>{changesNotSavedText}</p>
                    </div>
                  )}
                </Content>
              )}
            </form>
          )}
        />
        {!linkCode && (
          <div className="u-margin-bottom-2">
            <NavigationButton.Tertiary
              onClick={() => {
                if (isEdit) {
                  onCancelEditClick();
                }
                this.contactEditClick();
              }}
              labelText={!isEdit ? 'Edit' : 'Cancel Editing'}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ContactDetailsAccordionItem;
